import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { SelectionChangedEvent, ColGroupDef, ColDef } from '@ag-grid-enterprise/all-modules';
import { UtimacoPacketSwitch } from 'data/utimacoPacketSwitch/utimacoPacketSwitch.types';
import CommonGrid from 'shared/commonGrid';
import { ROWSELECTION } from 'shared/commonGrid/grid-enums';
import ActionMenuCellRenderer from 'shared/commonGrid/action-menu-cell-renderer';
import ActionMenus from 'components/ActionMenus';
import UtimacoPacketSwitchListGridActionMenu from '../UtimacoPacketSwitchListGridActionMenu';

interface Props {
  data: UtimacoPacketSwitch[]
  hasPrivilegeToView: boolean
  hasPrivilegesToCreate: boolean
  hasPrivilegeToDelete: boolean
  noResults: boolean,
  beforeLogout: boolean,
  lastUpdatedAt: Date | undefined,
  columnDefs: (ColGroupDef | ColDef)[],
  selectedUtimacoPacketSwitch: UtimacoPacketSwitch
  onRefresh: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
  onCreateNew: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
  onSelectionChanged: (event: SelectionChangedEvent) => void
  onSelectItemMenuAction: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void
  onShowActionMenuItem: (menuId: string, data: UtimacoPacketSwitch[]) => void
  onDeleteRow: () => void
  onEdit: () => void
}

const UtimacoPacketSwitchListGrid: FunctionComponent<Props> = ({
  hasPrivilegesToCreate,
  hasPrivilegeToDelete,
  hasPrivilegeToView,
  data = [],
  noResults,
  beforeLogout,
  lastUpdatedAt,
  columnDefs,
  selectedUtimacoPacketSwitch,
  onDeleteRow,
  onEdit,
  onCreateNew,
  onRefresh,
  onSelectionChanged,
  onShowActionMenuItem,
  onSelectItemMenuAction,
}: Props) => {
  const components = {
    actionMenuCellRenderer: ActionMenuCellRenderer,
  };
  const { t } = useTranslation();

  return (
    <div className="grid-container" style={{ height: 'inherit' }} data-testid="UtimacoPacketSwitchList">
      <CommonGrid
        createNewText={t('dialedDigitExtractionServer.grid.newUtimacoPacketSwitch')}
        pagination
        enableBrowserTooltips
        rowSelection={ROWSELECTION.SINGLE}
        hasPrivilegeToCreateNew={hasPrivilegesToCreate}
        hasPrivilegeToDelete={hasPrivilegeToDelete}
        hasPrivilegetoView={hasPrivilegeToView}
        rowData={data}
        noResults={noResults}
        isBeforeLogout={beforeLogout}
        columnDefs={columnDefs}
        components={components}
        actionMenuClass={UtimacoPacketSwitchListGridActionMenu}
        handleCreateNew={onCreateNew}
        onRefresh={onRefresh}
        onSelectionChanged={onSelectionChanged}
        showActionMenuItem={onShowActionMenuItem}
        onActionMenuItemClick={onSelectItemMenuAction}
        lastUpdatedAt={lastUpdatedAt}
      >
        <ActionMenus
          name={selectedUtimacoPacketSwitch?.AFID}
          deleteTitle={t('utimacoPacketSwitch.deletePopup.title')}
          deleteMessage={t('utimacoPacketSwitch.deletePopup.message')}
          hasPrivilegesToCreate={hasPrivilegesToCreate}
          hasPrivilegeToDelete={hasPrivilegeToDelete}
          onEdit={onEdit}
          onDelete={onDeleteRow}
        />
      </CommonGrid>
    </div>
  );
};

export default UtimacoPacketSwitchListGrid;
